import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { GlobalConfigService } from './global-config.service';
import { ILoginRequest } from '../models/login.model';
import { IUser } from '../models/user.model';
import { IError } from '../models/error.model';

export interface IVerifyCodeResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/auth';
  }

  constructor(
    private userService: UserService,
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }

  login(username: string, password: string): Promise<IUser> {
    let request: ILoginRequest = {
      email: username,
      password,
    };
    return this.userService.authenticate(request);
  }

  /**
   * Envia um email com o código de recuperação de senha
   */
  forgotPassword(email: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.post<void>(`${this.baseUrl}/forgot-password`, { email })
        .subscribe({
          next: () => resolve(),
          error: (err) => reject(err?.error || err)
        });
    });
  }

  /**
   * Verifica o código de recuperação de senha
   */
  verifyCode(email: string, code: string): Promise<IVerifyCodeResponse> {
    return new Promise((resolve, reject) => {
      this.http.post<IVerifyCodeResponse>(`${this.baseUrl}/verify-code`, { email, code })
        .subscribe({
          next: (response) => resolve(response),
          error: (err) => reject(err?.error || err)
        });
    });
  }

  /**
   * Confirma a troca de senha do usuário
   * Endpoint: /users/auth/confirm-forgot-password
   */
  resetPassword(email: string, confirmationCode: string, newPassword: string): Promise<void> {
    const url = this.globalConfig.getApiUrl() + '/users/auth/confirm-forgot-password';
    const payload = {
      email,
      confirmation_code: confirmationCode,
      new_password: newPassword
    };
    
    return new Promise((resolve, reject) => {
      this.http.post<void>(url, payload)
        .subscribe({
          next: () => resolve(),
          error: (err) => reject(err?.error || err)
        });
    });
  }
}
